import React from "react";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";
import "./index.css";
import Button from "@material-ui/core/Button";
import DirectionsCarOutlinedIcon from "@material-ui/icons/DirectionsCarOutlined";
import { connect } from "react-redux";
import moment from "moment";
import instance from "../../store/actions/instance";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import RoomServiceIcon from "@material-ui/icons/RoomService";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";

const PICKUP_BUTTON_DISABLED_INTERVAL = 10;
const WAITER_BUTTON_DISABLED_INTERVAL = 2;

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Address({
  order,
  language,
  themeColor,
  customTexts,
  settings,
  updateOrder,
  history,
}) {
  const [, updateState] = React.useState();
  const [alertOpen, setAlertOpen] = React.useState(false);
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const { address, pickup_from, is_delivery } = order;
  let interv;
  const pickupCallButtonDisabled = () => {
    if (!pickup_from) return true;

    if (order.status === "Complete") return true;
    if (order.last_arrival_request) {
      if (
        moment(order.last_arrival_request, "YYYY-MM-DD HH:mm:ss").add(
          settings.enable_table_qr
            ? WAITER_BUTTON_DISABLED_INTERVAL
            : PICKUP_BUTTON_DISABLED_INTERVAL,
          "minutes"
        ) > moment()
      ) {
        return true;
      }
    }
    if (settings.enable_table_qr) return false;
    let expected_delivery_date_time_start = moment(
      order.expected_delivery_date_time.split(" - ")[0],
      "YYYY-MM-DD HH:mm:ss"
    )
      .subtract(10, "minutes")
      .format("YYYY-MM-DD HH:mm:ss");
    const expected_delivery_date_end =
      order.expected_delivery_date_time.split(" - ")[1];
    if (
      moment().format("YYYY-MM-DD HH:mm:ss") >=
        expected_delivery_date_time_start &&
      moment().format("HH:mm:ss") <= expected_delivery_date_end
    )
      return false;
    return true;
  };

  const showIamHereButton = () => {
    if (!pickup_from) return false;
    if (order.status === "Complete") return false;
    if (settings.enable_table_qr) return true;
    const expected_delivery_date_end =
      order.expected_delivery_date_time.split(" - ")[1];
    const date = order.expected_delivery_date_time.split(" ")[0];
    const datetime = date + " " + expected_delivery_date_end;
    if (moment().format("YYYY-MM-DD HH:mm:ss") > datetime) return false;
    return true;
  };

  React.useEffect(() => {
    if (
      pickup_from &&
      showIamHereButton() &&
      pickupCallButtonDisabled() &&
      order.status !== "Complete"
    ) {
      interv = window.setInterval(() => {
        forceUpdate();
      }, 1000);
    }
    return () => {
      if (interv) window.clearInterval(interv);
    };
  }, [order]);

  if (settings.enable_car_qr) return <></>;
  if (
    settings.enable_table_qr &&
    (!settings.enable_pickup_arrival_requests || !order.table_token)
  )
    return <></>;
  const useAddressLines =
    address.country === "International" || address.province === "Kashtat";

  const getSubDeliveryAddressText = () => {
    let temp = useAddressLines ? address.block + ", " : "";
    temp += `${
      useAddressLines ? "" : language == "english" ? "Street" : "شارع"
    } ${address.street || "-"}`;
    if (address.avenue)
      temp = temp.concat(
        `, ${
          useAddressLines ? "" : language == "english" ? "avenue" : "جادة"
        } ${address.avenue}`
      );
    if (address.building)
      temp = temp.concat(
        `, ${language == "english" ? "building" : "مبنى"} ${address.building}`
      );
    if (address.floor)
      temp = temp.concat(
        `, ${language == "english" ? "floor" : "دور"} ${address.floor}`
      );
    if (address.apartment)
      temp = temp.concat(
        `, ${language == "english" ? "apartment" : "شقة"} ${address.apartment}`
      );
    if (address.paci)
      temp = temp.concat(
        `, ${language == "english" ? "PACI" : "الرقم الآلي"} ${address.paci}`
      );
    if (address.additional)
      temp = temp.concat(
        `, ${language == "english" ? "additional" : "اضافي"}: ${
          address.additional
        }`
      );
    return temp;
  };

  const customerAtLocationButtonClicked = async () => {
    try {
      const res = await instance.post("/customer_at_location/", {
        tracking_id: order.tracking_id,
        table_number: order.table_token,
      });
      updateOrder({
        ...order,
        last_arrival_request: moment().format("YYYY-MM-DD HH:mm:ss"),
      });
      setAlertOpen(true);
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <div
      className="border w-100 row m-0 mt-4"
      style={{ backgroundColor: "white", minHeight: 65 }}
    >
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={() => setAlertOpen(false)}
        classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
      >
        <Alert onClose={() => setAlertOpen(false)} severity="success">
          {settings.enable_table_qr
            ? language === "english"
              ? "A waiter has been notified!"
              : "تم ارسال اشعار لموظفي الخدمة"
            : language == "english"
            ? "The branch has been notified!"
            : "تم ارسال اشعار للفرع بوصولك"}
        </Alert>
      </Snackbar>
      {!settings.enable_table_qr && (
        <>
          <div className="col-2" style={{ position: "relative" }}>
            <LocationOnOutlinedIcon
              className="center-x-y"
              style={{ fontSize: 32, color: "#999" }}
            />
          </div>
          <div
            className={"col-10 py-3 ".concat(
              language == "english" ? "text-left" : "text-right"
            )}
            style={
              address?.province === "Mosques"
                ? {
                    alignContent: "center",
                  }
                : {}
            }
          >
            <p
              style={{
                fontWeight: "bold",
                margin: 0,
                marginBottom: is_delivery ? 5 : 2,
                marginTop: order.unknown_gift_recipient_location ? 10 : 0,
              }}
            >
              {is_delivery ? (
                <>
                  {order.unknown_gift_recipient_location ? (
                    (language == "english" ? address.area : address.area_ar) ||
                    (language == "english"
                      ? address.district
                      : address.district_ar)
                  ) : (
                    <>
                      {(language == "english"
                        ? address.area
                        : address.area_ar) ||
                        (language == "english"
                          ? address.district
                          : address.district_ar)}
                      {!useAddressLines && address.province !== "Mosques" && (
                        <>
                          {`${
                            address.zone !== "-" || !!address.block
                              ? address.block
                                ? language == "english"
                                  ? ", block"
                                  : address.country === "Bahrain"
                                  ? ", مجمع"
                                  : ", قطعة"
                                : language == "english"
                                ? ", zone"
                                : ", منطقة"
                              : ""
                          }`}{" "}
                          {address.block ||
                            (address.zone !== "-" ? address.zone : "")}
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <span
                  style={{
                    lineHeight:
                      pickup_from?.branch_lat && pickup_from?.branch_lng
                        ? 1
                        : 2.5,
                  }}
                >{`${
                  language == "english"
                    ? `${customTexts.pickup} from`
                    : `${customTexts.pickup_ar} من`
                } ${
                  language == "english"
                    ? pickup_from.branch
                    : pickup_from.branch_ar
                }`}</span>
              )}
            </p>
            {is_delivery && address?.province !== "Mosques" ? (
              <p>
                {order.unknown_gift_recipient_location
                  ? ""
                  : getSubDeliveryAddressText()}
              </p>
            ) : pickup_from?.branch_lat && pickup_from?.branch_lng ? (
              <>
                {" "}
                <Button
                  color="primary"
                  style={{
                    textTransform: "capitalize",
                    paddingRight: language == "arabic" && 0,
                    paddingLeft: language == "english" && 0,
                  }}
                  startIcon={<DirectionsCarOutlinedIcon />}
                >
                  <a
                    href={`https://maps.google.com/maps?daddr=${pickup_from.branch_lat},${pickup_from.branch_lng}`}
                    target="_blank"
                    style={{
                      color: themeColor,
                      marginRight: language == "arabic" && 8,
                    }}
                  >
                    {language == "english" ? "Get directions" : "الاتجاهات"}
                  </a>
                </Button>
              </>
            ) : null}
          </div>
        </>
      )}
      {showIamHereButton() &&
        !is_delivery &&
        !!pickup_from &&
        settings.enable_pickup_arrival_requests && (
          <div
            className="bold col-12 mb-3"
            style={{
              margin: "auto",
              maxWidth: 400,
              marginTop: settings.enable_table_qr ? 14 : 0,
            }}
          >
            {/* <p>Click the button below 10 minutes before arriving</p> */}

            <div style={{ display: "flex", gap: 10, height: 45 }}>
              {settings.enable_table_qr && (
                <Button
                  color="primary"
                  style={{
                    textTransform: "capitalize",
                    boxShadow: "none",
                    width: "100%",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() => history?.replace("/")}
                  startIcon={
                    <AddShoppingCartIcon
                      style={
                        language === "arabic"
                          ? { position: "relative", right: -10 }
                          : {}
                      }
                    />
                  }
                >
                  {language === "arabic" ? "استمر بالطلب" : "Continue Ordering"}
                </Button>
              )}
              <Button
                color="primary"
                style={{
                  textTransform: "capitalize",
                  boxShadow: "none",
                  width: "100%",
                  textTransform: "none",
                }}
                variant="outlined"
                disabled={pickupCallButtonDisabled()}
                onClick={() => customerAtLocationButtonClicked()}
                startIcon={
                  settings.enable_table_qr ? (
                    <RoomServiceIcon
                      style={
                        language === "arabic"
                          ? { position: "relative", right: -10 }
                          : {}
                      }
                    />
                  ) : (
                    <></>
                  )
                }
              >
                {!settings.enable_table_qr
                  ? language === "arabic"
                    ? "لقد وصلت. أخبر الفرع"
                    : "Tell the branch I have arrived"
                  : language === "arabic"
                  ? "احتاج الى موظف خدمة"
                  : "I need a waiter"}
              </Button>
            </div>

            {pickupCallButtonDisabled() && (
              <div
                className={"mt-2 ".concat(
                  language === "arabic" ? "mr-3" : "ml-3"
                )}
              >
                {language === "arabic" ? "متاح" : "Available"}
                {!!order.last_arrival_request
                  ? language === "arabic"
                    ? " مرة اخرى "
                    : " again "
                  : " "}
                {language === "arabic" ? "بعد" : "after"}{" "}
                {!!order.last_arrival_request
                  ? `${
                      settings.enable_table_qr
                        ? WAITER_BUTTON_DISABLED_INTERVAL
                        : PICKUP_BUTTON_DISABLED_INTERVAL
                    } ${
                      language === "arabic"
                        ? settings.enable_table_qr
                          ? "دقيقة"
                          : "دقائق"
                        : "minutes"
                    }`
                  : moment(
                      order.expected_delivery_date_time.split(" - ")[0],
                      "YYYY-MM-DD HH:mm:ss"
                    )
                      .subtract(10, "minutes")
                      .format("h:mm A")
                      .replace("AM", language === "arabic" ? "ص" : "AM")
                      .replace("PM", language === "arabic" ? "م" : "PM")}
              </div>
            )}
          </div>
        )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark || "#0099cc",
    customTexts: state.store.store.settings.custom_texts,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(Address);
